// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalB_wrapper__3AP_E","container":"ModalB_container__31HN5","body":"ModalB_body__2kG3_","footer":"ModalB_footer__YeU5P"};